import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'description',
        title: 'Filtre Adı',
        rules: {required: true, min: 3 },
        modal: ['description'],
        data: ['description'],
        additionalButton: false,
        checkBox: false,
    },
    {
        type: 'multiInput',
        name: 'details',
        default: [{key: null, value: null}],
        title: 'Filtrelenecek Alanlar',
        modal: ['details'],
        data:['details'],
        inputs:[
            {
                type: 'select',
                name: 'ADAttribute',
                title: 'AD Alanı',
                rules: {required: true},
                modal: ['key'],
                data: ['key'],
                options: {
                    data: [],
                    label: 'name',
                    track: 'name',
                    key: 'id'
                },
                additionalButton: false,
                checkBox: false
            },
            {
                type: 'text',
                name: 'value',
                title: 'Değer',
                rules: { },
                modal: ['value'],
                data: ['value'],
                additionalButton: false,
                checkBox: false,
            },
        ],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'multiInput',
        name: 'columns',
        default: [{name: null}],
        title: 'Listelenecek Alanlar',
        modal: ['columns'],
        data:['columns'],
        inputs:[
            {
                type: 'select',
                name: 'ADAttribute',
                title: 'AD Alanı',
                rules: {required: true},
                modal: ['name'],
                data: ['name'],
                options: {
                    data: [],
                    label: 'name',
                    track: 'name',
                    key: 'id'
                },
                additionalButton: false,
                checkBox: false
            }
        ],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Users/forms/ADFilterForm.js